<template>
    <div class="details">
      <div class="details_part1" :class="'details_part1'+skinNum">
        <div class="details_part1_mess">
          <p v-html="form.content" v-if="form.content!=null&&form.content!=''" class="vHtmlMess"></p>
          <img :src="form.activityUrl" alt="" v-if="form.activityUrl!=null&&form.activityUrl!=''">
          <!--<video :src="form.activityVideoUrl" class="part1_video" v-if="form.activityVideoUrl!=''"></video>-->
          <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsline="false" :options="playerOptions" v-if="form.activityVideoUrl!=''&&form.activityVideoUrl!=null"></video-player>
        </div>
      </div>
      <div class="details_part2">
         <div class="details_part">
          <p :class="'part'+skinNum"></p>
          <p :class="'part_tit'+skinNum">组织机构</p>
          <p :class="'part_eng'+skinNum"></p>
        </div>
        <div class="part2_mess" :class="'part2_mess' + skinNum">
          <p v-if="organizationList.length>0" v-for="(item,index) in organizationList" :key="index">
            <!-- {{ item.organizationName }} -->
          <span>
            {{ item.organizationName }}
          </span>
            <span>{{ item.organizationContent }}</span>
          </p>
          <div class="con_part2" v-if="logoList.length>0">
            <p>合作方</p>
            <div class="con_part2box">
              <img :src="item.url" alt="" v-for="(item,index) in logoList" :key="index">
            </div>
          </div>
        </div>
      </div>
      <div class="details_part3" v-if="wayList.length>0">
        <div class="details_part">
          <p :class="'part'+skinNum"></p>
          <p :class="'part_tit'+skinNum">奖项设置</p>
          <p :class="'part_eng'+skinNum"></p>
        </div>
        <!--<carousel-box :awardList='wayList'></carousel-box>-->
        <div class="details_part_title" style="margin-top: 36px;"
             v-for="(item,index) in wayList" :key="index"
             v-if="wayList.length>0">
          <div class="wayBack">
            <div class="flex">
              <!-- <p :class="'wayCss' + skinNum"> 赛道{{ numberFilter(index+1) }}：</p> -->
              <p :class="'wayCss' + skinNum"> {{ item.name }} </p>              
            </div>
          </div>
          <carousel-box :awardList='item.awardList' :awardIndex="index + 1" :skinNum="skinNum"></carousel-box>
        </div>
      </div>
      <div class="details_part4" v-if="nodeList.length==4||nodeList.lenth<4">
        <div class="details_part">
          <p :class="'part'+skinNum"></p>
          <p :class="'part_tit'+skinNum">活动时间</p>
          <p :class="'part_eng'+skinNum"></p>
        </div>
        <div class="part4_time">
          <img :src="skinNum == 0 ?require('../../../assets/activelistImg/liu3.png'): skinNum == 1 ? require('../../../assets/activelistImg/liu4.png') : require('../../../assets/activelistImg/liu5.png')" alt="" class="part4_time_img">
          <div :class="'part4_time_date part4_time_date_mess'+(index+1)"
               v-for="(item,index) in nodeList"
               :key="index"
               v-if="nodeList.length>0">
            <p :class="'part4_time_date1' +skinNum">{{ item.name }}</p>
            <p :class="'part4_time_date2' +skinNum ">{{ getDateYear(item.startDate) }}</p>
            <p :class="'part4_time_date3'+skinNum " v-if="item.dateType==='DATE'">{{ getDateMonth(item.startDate) }}</p>
            <p :class="'part4_time_date3'+skinNum " v-if="item.dateType==='RANGE'">
              <span>{{ getDateMonth(item.startDate) }}</span>
              <i class="el-icon-caret-right"></i>
              <span>{{ getDateMonth(item.endDate) }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="details_parts" v-if="nodeList.length==5">
        <div class="details_part">
          <p :class="'part'+skinNum"></p>
          <p :class="'part_tit'+skinNum">活动时间</p>
          <p :class="'part_eng'+skinNum"></p>
        </div>
        <div class="part4_time">
          <img :src="skinNum == 0 ?require('../../../assets/activelistImg/liu3.png'): skinNum == 1 ? require('../../../assets/activelistImg/liu4.png') : require('../../../assets/activelistImg/liu5.png')"  alt="" class="part4_time_img">
          <div :class="'part4_time_date part4_time_date_mess'+(index+1)"
               v-for="(item,index) in nodeList"
               :key="index"
               v-if="nodeList.length>0">
            <p class="part4_time_date1">{{ item.name }}</p>
            <p class="part4_time_date2">{{ getDateYear(item.startDate) }}</p>
            <p class="part4_time_date3" v-if="item.dateType==='DATE'">{{ getDateMonth(item.startDate) }}</p>
            <p class="part4_time_date3" v-if="item.dateType==='RANGE'">
              <span>{{ getDateMonth(item.startDate) }}</span>
              <i class="el-icon-caret-right"></i>
              <span>{{ getDateMonth(item.endDate) }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="details_part5 clearfix" v-if="form.entryDemand!=null&&form.entryDemand!=''">
        <div class="details_part">
          <p :class="'part'+skinNum"></p>
          <p :class="'part_tit'+skinNum">参赛要求</p>
          <p :class="'part_eng'+skinNum"></p>
        </div>
        <div class="part5_mess vHtmlMess" v-html="form.entryDemand">
          <!-- <p v-html="form.entryDemand"></p> -->
        </div>
      </div>
      <div class="details_part6" v-if="form.entryRule!=null&&form.entryRule!=''">
        <div class="details_part">
          <p :class="'part'+skinNum"></p>
          <p :class="'part_tit'+skinNum">参赛规则</p>
          <p :class="'part_eng'+skinNum"></p>
        </div>
        <div class="part6_mess">
          <div class="part6_mess_box">
            <p v-html="form.entryRule" class="vHtmlMess"></p>
          </div>
        </div>
      </div>
      <div class="details_part7" v-show="fileList.length > 0 || form.fileContent">
        <div class="details_part">
          <p :class="'part'+skinNum"></p>
          <p :class="'part_tit'+skinNum">相关资料</p>
          <p :class="'part_eng'+skinNum"></p>
        </div>
        <div class="part7_mess">
          <div class="part7_mes_box vHtmlMess" v-html="form.fileContent" v-if="form.fileContent!=null&&form.fileContent!=''"></div>
          <div class="part7_button" v-if="fileList.length>0">
            <p v-for="(item,index) in form.fileList" :key="index" @click="downloadFile(item.url,item.name)">{{ item.name }}</p>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import { getActivityDetailInfo } from '../../../utils/interface';
import carouselBox from './carouselBox2';

export default {
  name:"activeDetailsRefs",
  data(){
    return {
      form:{},
      logoList:[],
      awardList:[],
      fileList:[],
      nodeList:[],
      wayList:[],
      organizationList:[],
      styleName:"",
      skinNum:0,
      playerOptions : {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器
        sources: [{
          type: "video/mp4",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
          src: "" //url地址
        }],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          fullscreenToggle: false  //全屏按钮
        },
      },
    }
  },
  components:{
    carouselBox
  },
  mounted(){

  },
  methods: {
    numberFilter (num) {
      const changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'] // changeNum[0] = "零"
      const unit = ['', '十', '百']
      num = parseInt(num)
      const getWan = (temp) => {
        const strArr = temp.toString().split('').reverse()
        let newNum = ''
        for (let i = 0; i < strArr.length; i++) {
          newNum = (i == 0 && strArr[i] == 0 ? '' : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? '' : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum
        }
        return newNum
      }
      const overWan = Math.floor(num / 100)
      let noWan = num % 100
      if (noWan.toString().length < 2) noWan = '0' + noWan
      let strr = (overWan ? getWan(overWan) + '百' + getWan(noWan) : getWan(num))
      if(strr.split('')[0] == '一'){
        let showNum = "";
        if(strr == '一'){
          showNum = strr.substring(0);
        }else{
          showNum = strr.substring(1);
        }
        return showNum
      }else{
        let showNum = overWan ? getWan(overWan) + '百' + getWan(noWan) : getWan(num);
        return showNum
      }
    },
    init(uuid) {
      this.form = {};
      getActivityDetailInfo({uuid:uuid}).then((res)=>{
        this.form = res;
        this.logoList = res.logoList;
        this.nodeList = res.nodeList;
        this.wayList = res.wayList;
        this.organizationList = res.organizationList;
        this.styleName = res.styleName;
        console.log('this.styleNamethis.styleName', this.styleName);
        if(this.styleName == "skin1"){
          this.skinNum = 0;
        } else if(this.styleName == "skin2"){
          this.skinNum = 1;
        } else if(this.styleName == "skin3"){
          this.skinNum = 2;
        }
        //this.awardList = res.awardList;
        this.fileList = res.fileList;
        if(this.form.activityVideoUrl!=''){
          this.playerOptions.sources[0].src = this.form.activityVideoUrl;
        }
      });
    },
    getDateYear(value){
      let date = new Date(value);
      let y = date.getFullYear();
      return y;
    },
    getDateMonth(value){
      let date = new Date(value);
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return MM + "." + d;
    },
    downloadFile(fileUrl,name){
      const x = new window.XMLHttpRequest();
      x.open('GET', fileUrl, true);
      x.responseType = 'blob';
      x.onload = () => {
          const url = window.URL.createObjectURL(x.response);
          const a = document.createElement('a');
          a.href = url;
          a.download = name;
          a.click();
      };
      x.send();
    },
    // downloadFile(fileUrl){
    //   let a = document.createElement('a');
    //   a.href = fileUrl;
    //   a.click();
    // },
  },
}
</script>
<style scoped lang="less">
.details {
  width: 1200px;
  margin: 25px auto 51px;
  padding: 44px 70px 20px;
  box-sizing: border-box;
  .details_part {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    text-align: center;
    width: 390px;
    height: 60px;
    background: #FFFFFF;
    box-shadow: 0px 10px 12px 0px rgba(94, 149, 150, 0.35);
    border-radius: 41px;
    color: #5b96b9;
    overflow: hidden;
    position: relative;
    left: 50%;
    transform: translate(-50%, 0);
    .part0{
      border-radius: 50%;
      background: #FECA43;
      width: 184px;
      height: 142px;
      position: absolute;
      top: -88px;
      left: -76px;
    }
    .part1{
      border-radius: 50%;
      background: #5c39fe;
      width: 184px;
      height: 142px;
      position: absolute;
      top: -88px;
      left: -76px;
    }
    .part2{
      border-radius: 50%;
      background: #fec944;
      width: 184px;
      height: 142px;
      position: absolute;
      top: -88px;
      left: -76px;
    }
    .part_tit0 {
      font-size: 20px;
      font-family: RTWS ShangGothic G0v1;
      color: #5b96b9;
      margin: 4px 0;
      position: absolute;
      top: 50%;
      right: 50%;
      transform: translate(50%, -54%);
    }
    .part_tit1 {
      font-size: 20px;
      font-family: RTWS ShangGothic G0v1;
      color: #c34188;
      margin: 4px 0;
      position: absolute;
      top: 50%;
      right: 50%;
      transform: translate(50%, -54%);
    }
    .part_tit2 {
      font-size: 20px;
      font-family: RTWS ShangGothic G0v1;
      color: #6acb9f;
      margin: 4px 0;
      position: absolute;
      top: 50%;
      right: 50%;
      transform: translate(50%, -54%);
    }
    .part_eng0 {
      border-radius: 50%;
      background: #5b96b9;
      width: 256px;
      height: 130px;
      position: absolute;
      bottom: -98px;
      right: -98px;
    }
    .part_eng1 {
      border-radius: 50%;
      background: #c34188;
      width: 256px;
      height: 130px;
      position: absolute;
      bottom: -98px;
      right: -98px;
    }
    .part_eng2 {
      border-radius: 50%;
      background: #64c69c;
      width: 256px;
      height: 130px;
      position: absolute;
      bottom: -98px;
      right: -98px;
    }
  }
  .details_part1 {
    text-align: center;
    background: linear-gradient(90deg, #fcd363c8, #fad14bbe);
    box-shadow: 0px 10px 12px 0px rgba(94, 149, 150, 0.35);
    border-radius: 10px;
    padding: 45px 48px;
    .details_part1_mess {
      font-size: 14px;
      line-height: 28px;
      p {
        margin: 28px 0;
        margin-top: 0;
      }
      /deep/img {
        max-width: 100%;
      }
    }
    .part1_video {
      width: 961px;
      height: 486px;
      background: rgba(243, 243, 243, 0.39);
      border-radius: 10px;;
    }
  }
  .details_part11 {
    background: #997becc2;
  }
  .details_part2 {
    margin: 93px 0 83px;
    .part2_mess {
      font-size: 14px;
      background: #fff;
      border-radius: 10px;;
      margin-top: 57px;
      padding: 20px;
      p {
        display: flex;
        align-items: center;
        color: #646464;
        margin-bottom: 8px;
        flex-shrink: 0;
        span:first-child{
          color: #c5a7d1;
          margin-left: 8px;
          display: inline-block;
          min-width: 60px;
        }
        span {
          color: #157EFB;
          margin-left: 8px;
        }
      }
      .con_part2 {
        margin-top: 27px;
        display: flex;
        // align-items: center;
        color: #646464;
        margin-bottom: 8px;
        flex-shrink: 0;

        .con_part2box {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
        img {
            width: 190px;
            height: 90px;
            margin-right: 20px;
            margin-left: 8px;
            margin-bottom: 10px;
          }
        }
        p {
			    min-width: 60px;
          align-items: flex-start;
          // margin-top: 10px;
          color: #c5a7d1;
		      font-weight: bold;
		      margin-left: 8px;
			    line-height: 90px;
        }

      }
    }
    .part2_mess2 {
      p {
        color: #646464;
        span:first-child{
          color: #646464;
        }
      }
      .con_part2 {
         p {
          color: #646464;
        }
      }
    }
  }
  .details_part3 {
    margin-bottom: 100px;
    .part3_mess {
      padding-top: 62px;
      display: flex;
      // justify-content: space-between;
      align-items: center;
      overflow-x: auto;
      /*定义滚动条样式*/
      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background: rgba(240,240,240,1);
      }
　　   /*定义滚动条轨道内阴影+圆角*/
      ::-webkit-scrollbar-track {
        box-shadow: inset000pxrgba(240,240,240,.5);
        border-radius: 10px;
        background: rgba(240,240,240,.5);
      }
  　　/*定义滑块内阴影+圆角*/
      ::-webkit-slider-thumb {
        border-radius: 10px;
        box-shadow: inset000pxrgba(240,240,240,.5);
        background: rgba(240,240,240,.5);
      }
    }
    .part3_mess_pre {
      position: relative;
      font-size: 18px;
      font-weight: bold;
      color: #000000;
      width: 249px;
      height: 307px;
      background: rgba(248, 248, 248);
      border-radius: 10px;
      margin-right: 115px;
      flex-shrink: 0;
      &:nth-last-of-type(1){
        margin-right: 0;
      }
      .pre_part3_tit {
        width: 137px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        background: rgba(21, 126, 251);
        border-radius: 26px;
        color: #fff;
        position: absolute;
        left: 50%;
        top: -6%;
        transform: translate(-50%, 0);
      }
      .pre_part3_me {
        text-align: center;
        padding-top: 24%;
      }
      img {
        width: 120px;
        height: 154px;
        position: absolute;
        bottom: 8px;
        right: -17px;
      }
    }
    .part3_mess_pre:nth-of-type(2)  {
      position: relative;
      font-size: 22px;
      font-weight: bold;
      color: #000000;
      width: 306px;
      height: 378px;
      background: rgba(248, 248, 248);
      border-radius: 10px;
      .pre_part3_tit {
        width: 168px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: rgba(21, 126, 251);
        border-radius: 26px;
        color: #fff;
        position: absolute;
        left: 50%;
        top: -6%;
        transform: translate(-50%, 0);
      }
      .pre_part3_me {
        text-align: center;
        padding-top: 24%;
        font-size: 21px;
      }
      img {
        width: 396px;
        height: 133px;
        position: absolute;
        bottom: 8px;
        right: -78px;
      }
    }
  }
  .details_part4 {
    margin-bottom: 219px;
    .part4_time {
      position: relative;
      margin-top: 176px;
      .part4_time_img {
        width: 100%;
      }
      .part4_time_date {
        position: absolute;
        top: -110px;
        left: 0;
        .part4_time_date10 {
          width: 120px;
          height: 40px;
          background: #fff;
          border-radius: 20px;
          font-size: 16px;    
          color: #85adca;   
          line-height: 40px;
          text-align: center;
        }
        .part4_time_date11 {
          width: 120px;
          height: 40px;
          background: #fff;
          border-radius: 20px;
          font-size: 16px;    
          color: #b362a4;   
          line-height: 40px;
          text-align: center;
        }
        .part4_time_date12 {
          width: 120px;
          height: 40px;
          background: #fff;
          border-radius: 20px;
          font-size: 16px;    
          color: #64c69c;   
          line-height: 40px;
          text-align: center;
        }
        
        .part4_time_date2 {
          font-size: 16px;
          margin: 3px 0;
        }
        .part4_time_date3 {
          font-size: 24px;
          font-weight: bold;
          display: flex;
        }
      }
      .part4_time_date_mess2 {
        top: 31px;
        left: 27%;
        .part4_time_date3 {
          display: flex;
          align-items: center;
          i {
            color: rgba(216, 216, 216);
            font-size: 17px;
            margin: 0 5px;
          }
        }
      }
      .part4_time_date_mess3 {
        left: 56%;
        .part4_time_date3 {
          display: flex;
          align-items: center;
          i {
            color: rgba(216, 216, 216);
            font-size: 17px;
            margin: 0 5px;
          }
        }
      }
      .part4_time_date_mess4 {
        top: 31px;
        left: 87%;
      }

    }
  }
   .details_parts {
    margin-bottom: 219px;
    .part4_time {
      position: relative;
      margin-top: 176px;
      .part4_time_img {
        width: 100%;
      }
      .part4_time_date {
        position: absolute;
        top: -110px;
        left: 0;
        .part4_time_date1 {
          width: 120px;
          height: 40px;
          background: #fff;
          border-radius: 20px;
          font-size: 16px;    
          line-height: 40px;
          color: #5b96b9;
          text-align: center;
        }
        .part4_time_date2 {
          font-size: 16px;
          margin: 3px 0;
          color: #6775ab;
        }
        .part4_time_date3 {
          font-size: 24px;
          font-weight: bold;
          display: flex;
          color: #6775ab;
        }
      }
      .part4_time_date_mess2 {
        top: 31px;
        left: 21%;
        .part4_time_date3 {
          display: flex;
          align-items: center;
          i {
            color: rgba(216, 216, 216);
            font-size: 17px;
            margin: 0 5px;
          }
        }
      }
      .part4_time_date_mess3 {
        left: 46%;
        .part4_time_date3 {
          display: flex;
          align-items: center;
          i {
            color: rgba(216, 216, 216);
            font-size: 17px;
            margin: 0 5px;
          }
        }
      }
      .part4_time_date_mess4 {
        top: 31px;
        left: 70%;
      }
      .part4_time_date_mess5 {
        // top: 31px;
        left: 91%;
      }
    }
  }
  .details_part5 {
    margin-bottom: 100px;
    .part5_mess {
      margin-top: 19px;
      /deep/img {
        max-width: 100%;
      }
      
      // font-size: 14px;
      // color: #646464;
      // line-height: 28px;
    }
  }
  .clearfix::after{
        content: "";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
    }
  .details_part6 {
    margin-bottom: 100px;
    .part6_mess {
      margin-top: 25px;
      .part6_mess_box {
        /deep/img {
          max-width: 100%;
        }
        // font-size: 14px;
        // line-height: 28px;
        // color: #646464;
        &:nth-of-type(1){
          margin-bottom: 30px;
        }
      }
    }
  }
  .details_part7 {
    .part7_mess {
      margin-top: 30px;
      .part7_mes_box {
        margin: 32px 0 20px;
        /deep/img {
          max-width: 100%;
        }
      }
      .part7_button {
        // display: flex;
        // align-items: center;
        cursor: pointer;
        .part7_button_icon {
          width: 40px;
          height: 40px;
          background: rgba(245, 245, 245, 0.39);
          border-radius: 12px;
          color: #1C7EF3;
          text-align: center;
          line-height: 40px;
          i {
            font-size: 30px;
            color: #1C7EF3;
          }
        }
        p {
          font-size: 14px;
          color: #1C7EF3;
          margin-bottom: 9px;
        }
      }
    }
  }
  .wayBack{
    display: flex;
    align-items: center;
    justify-content: center;
    .wayBack_box {
      display: flex;
      align-items: center;
      i {
        display: inline-block;
      }
      .wayBack_box_line0 {
        width: 74px;
        height: 2px;
        background: #1C7EF3;
      }
      .wayBack_box_line1 {
        width: 74px;
        height: 2px;
        background: #B0B1E5;
      }
      .wayBack_box_line2 {
        width: 74px;
        height: 2px;
        background: #61B45C;
      }
      .wayBack_box_round0 {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #1C7EF3;
      }
       .wayBack_box_round1 {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #B0B1E5;
      }
       .wayBack_box_round2 {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #61B45C;
      }
    }
  }
  .wayCss0{
    margin: 4px 0;
    font-size: 18px;
    color: #6775ab;
    font-size: 16px;
    font-weight: normal;
  }
  .wayCss1{
    margin: 4px 0;
    font-size: 18px;
    color: #b362a4;
    font-size: 16px;
    font-weight: normal;
  }
  .wayCss2{
    margin: 4px 0;
    font-size: 18px;
    color: #64c69c;
    font-size: 16px;
    font-weight: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/design/activeList/activeZhutwoDetail.vue